import { defineMessages } from 'react-intl';

const messages = defineMessages({
  favorites: {
    id: 'react.headerAndFooter.components.ArtistMetrics.favorites',
defaultMessage: 'Favorites received',
    description: 'Label for favorites icon in Header',
    },
  followers: {
    id: 'react.headerAndFooter.components.ArtistMetrics.followers',
defaultMessage: 'Followers',
    description: 'Label for followers icon in Header',
    },
  productsSold: {
    id: 'react.headerAndFooter.components.ArtistMetrics.productsSold',
defaultMessage: 'Products sold',
    description: 'Label for products sold icon in Header',
    },
  dashboardLabel: {
    id: 'react.headerAndFooter.components.ArtistMetrics.dashboardLabel',
defaultMessage: 'Dashboard',
    description: 'Label for dashboard tooltip in Header',
    },
  viewDashboard: {
    id: 'react.headerAndFooter.components.ArtistMetrics.viewDashboard',
defaultMessage: 'View Dashboard',
    description: 'Label for dashboard link in Header',
    },
});

export default messages;
